import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../Icons'

const ErrorPaymentModal = ({ isOpen, handleClose, handleGoBack }) => {
  const { t } = useTranslation(['payment', 'common'])
  if (!isOpen) return null
  return (
    <div className="error-payment-modal">
      <div className="error-payment-modal__container">
        <Icon
          icon="cross"
          viewBox="0 0 20 20"
          styles={{
            borderRadius: '100%',
            padding: '4px',
            fill: '#CE2C21',
            height: '30px',
            width: '30px',
            outline: '2px solid #CE2C21',
          }}
        />
        <h1>{t('payment:error.title')}</h1>
        <div className="description-body">{t('payment:error.cardDetails')}</div>
        <div className="footer-buttons">
          <button className="button button-red transparent" onClick={handleGoBack}>
            {t('common:actions.close')}
          </button>
          <button className="button button-red" onClick={handleClose}>
            {t('payment:error.checkCardRetry')}
          </button>
        </div>
      </div>
    </div>
  )
}

ErrorPaymentModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  handleGoBack: PropTypes.func,
}

export default ErrorPaymentModal
